import { FormsService } from "../../../services/forms/forms.service";
import { DeletePromoCodeActionType } from "../types";

export function* deletePromoCodeSaga({ payload }: DeletePromoCodeActionType) {
    try {
        yield FormsService.deletePaymentPromoCode(payload.promoCodeId);
    } catch (error) {
        // yield put(Handle Error);
    }
}
